import { useBackbone } from '@visikon/backbone/src';
import { EnvironmentName } from '@visikon/backbone/src/env';

export function useIsLoggedIn() {
  return useBackbone((state) => !!state.authToken);
}

export function useIsEnv(env: EnvironmentName) {
  return useBackbone((state) => state.env === env);
}